import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { getSupportStats } from "@/lib/api";

const formatCount = (value) => Number(value || 0).toLocaleString();

export default function TransparencyFooter() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    getSupportStats()
      .then((data) => {
        if (alive) setStats(data);
      })
      .catch((err) => {
        console.error(err);
      });
    return () => {
      alive = false;
    };
  }, []);

  const count = useMemo(
    () => formatCount(stats?.active_supporter_count || stats?.lifetime_supporter_count || 0),
    [stats]
  );

  return (
    <div
      data-testid="transparency-footer"
      className="mt-8 pt-5 text-xs text-[hsl(var(--ink-muted))] leading-relaxed"
    >
      <em>
        This analysis was funded by <strong>{count} voters</strong>. Want to keep it ad-free and independent?{" "}
        <Link to="/support" className="ink-underline text-[hsl(var(--ink))]">
          Support the project →
        </Link>
      </em>
    </div>
  );
}
